import CaptainAppResource from "./captainApp.resource";

const captainAppModule = angular
  .module("app.resources.captainApp", [])
  .service("CaptainApp", CaptainAppResource);

export default captainAppModule;



// WEBPACK FOOTER //
// ./src/resources/captainApp/captainApp.module.js